import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinTarget_Pair_instance;
var PinTarget_entriesInitialized;
function PinTarget_initEntries() {
  if (PinTarget_entriesInitialized)
    return Unit_instance;
  PinTarget_entriesInitialized = true;
  PinTarget_Pair_instance = new (PinTarget())('Pair', 0);
}
var PinTargetClass;
function PinTarget() {
  if (PinTargetClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'PinTarget');
    PinTargetClass = $;
  }
  return PinTargetClass;
}
function PinTarget_Pair_getInstance() {
  PinTarget_initEntries();
  return PinTarget_Pair_instance;
}
//region block: exports
export {
  PinTarget_Pair_getInstance as PinTarget_Pair_getInstancecum83e4182vg,
};
//endregion

//# sourceMappingURL=PinTarget.mjs.map
